import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@design-system/box';
import { Button } from '@design-system/button';
import { Dotdotdot } from '@design-system/dotdotdot';
import { DropdownThreeDotsButton } from '@design-system/dropdown';
import { CATEGORIES, FontAwesomeIcon } from '@design-system/font-awesome-icon';
import { __, n__ } from '@design-system/i18n';
import { useMatchBreakpoint } from '@design-system/theme';
import { UsersAvatarList } from '@design-system/users-avatar-list';
import { styled } from 'styled-components';
import { Logo } from './Logo';
export const MainTitle = ({ JoinButtonComponent, collapsed = false, groupName, logoUrl, members = [], onMembersClick, onSearch, threeDotsButtonData, totalMembers, }) => {
    var _a, _b;
    const isBreakpointMorS = useMatchBreakpoint(['s', 'm']);
    const getMembersCountLabel = () => {
        if (!totalMembers) {
            return '';
        }
        return n__('%{count} member', '%{count} members', totalMembers).i__({
            count: totalMembers.toString(),
        });
    };
    const getTitleFontSize = () => {
        if (collapsed) {
            if (isBreakpointMorS) {
                return 'h4-semibold';
            }
            return 'h3-semibold';
        }
        if (isBreakpointMorS) {
            return 'h3-semibold';
        }
        return 'h2-semibold';
    };
    return (_jsxs(Wrapper, { children: [_jsxs(Box, { alignItems: "center", flex: 1, font: getTitleFontSize(), mr: 4, children: [collapsed ? (logoUrl ? (_jsx(Logo, { flex: 1, groupName: groupName, logoUrl: logoUrl, mr: 3, noBorder: true, size: {
                            l: '40px',
                            s: '32px',
                        } })) : (_jsx(DefaultLogoWrapper, { height: { _: '32px', m: '48px' }, mr: 3, width: { _: '32px', m: '48px' }, children: _jsx(FontAwesomeIcon, { color: "white", height: isBreakpointMorS ? '16px' : '20px', iconName: "user-group", iconType: CATEGORIES.SOLID }) }))) : null, _jsx(Dotdotdot, { clamp: 2, children: groupName })] }), (onSearch ||
                (!isBreakpointMorS && totalMembers) ||
                JoinButtonComponent ||
                threeDotsButtonData) && (_jsxs(Box, { mt: { _: 3, m: 0 }, children: [!isBreakpointMorS && totalMembers && totalMembers > 0 ? (_jsx(Box, { mr: 4, style: { cursor: collapsed ? 'default' : 'pointer' }, children: _jsx(UsersAvatarList, { onClickMore: onMembersClick, users: members, children: getMembersCountLabel() }) })) : null, onSearch ? (_jsx(Button, { "aria-label": __('Search'), icon: () => (_jsx(FontAwesomeIcon, { height: "12px", iconName: "magnifying-glass", iconType: CATEGORIES.SOLID })), onClick: onSearch, variant: "secondary" })) : null, _jsxs(Box, { ml: 2, children: [JoinButtonComponent ? JoinButtonComponent : null, threeDotsButtonData ? (_jsx(DropdownThreeDotsButton, { dataTestId: (_a = threeDotsButtonData.dataTestId) !== null && _a !== void 0 ? _a : 'main-title-three-dots-button', items: threeDotsButtonData.items, onClickItem: threeDotsButtonData.onClickItem, title: (_b = threeDotsButtonData.title) !== null && _b !== void 0 ? _b : '' })) : null] })] }))] }));
};
export default MainTitle;
const Wrapper = styled(Box).attrs(() => ({
    flexDirection: { _: 'column', m: 'row' },
    alignItems: { _: 'flex-start', m: 'center' },
    justifyContent: { _: 'flex-start', m: 'center' },
})) `
  flex-wrap: wrap;
  // Needed to make sure content is above the pseudo element background
  position: relative;
  width: 100%;
`;
const DefaultLogoWrapper = styled(Box) `
  border-radius: 10px;
  background-color: ${({ theme }) => theme.colors.primary};
  justify-content: center;
  align-items: center;
`;
//# sourceMappingURL=MainTitle.js.map